import { render, staticRenderFns } from "./CreateInstance.vue?vue&type=template&id=1a6ae5a0"
import script from "./CreateInstance.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateInstance.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports